import { render, staticRenderFns } from "./RichTextAtom.vue?vue&type=template&id=23416902&"
import script from "./RichTextAtom.vue?vue&type=script&lang=ts&"
export * from "./RichTextAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports